import { ApiService } from '../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
var QrCodeComponent = (function () {
    function QrCodeComponent(apiService, activatedRoute) {
        this.apiService = apiService;
        this.activatedRoute = activatedRoute;
        this.imgQrcode = '';
        this.totalAmount = null;
        this.sellerName = null;
        this.overdue = null;
        this.id = null;
        this.baseURL = environment.apiURL;
    }
    QrCodeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute.params.subscribe(function (params) {
            _this.id = params.id;
            _this.getQrcodeData(_this.id);
        });
    };
    QrCodeComponent.prototype.getQrcodeData = function (id) {
        var _this = this;
        this.apiService.getQrcodeInvoicePayment(id).subscribe(function (response) {
            _this.imgQrcode = _this.baseURL + response['qr_code_file'];
            _this.totalAmount = response['total_amount'];
            _this.sellerName = response['seller_name'];
        });
    };
    return QrCodeComponent;
}());
export { QrCodeComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/qr-code/qr-code.component.ts.pre-build-optimizer.js